{
	"id": 7504,
	"moduleNumber": 4,
	"slug": "module-4",
	"kgNodeId": "module-4",
	"title": "The Professional Educator and the School",
	"subtitle": "Balance school culture with ethics by upholding standards, documenting concerns, and protecting students.",
	"type": "lesson",
	"moduleKind": "standard",
	"moduleKindLabel": "Lesson",
	"sourceStatus": "extracted_from_source_documents",
	"summary": "Module 4 moves from educator-student decisions to school-level ethical obligations. The module centers on a field trip scenario involving educator responsibilities, student supervision, policy expectations, and school-community trust.",
	"estimatedDurationMinutes": 35,
	"activityCount": 2,
	"knowledgeCheck": {
		"included": true,
		"questionCount": 5
	},
	"learningObjectives": [
		"Analyze school-level ethical situations using dispositional and regulatory frameworks.",
		"Evaluate competing obligations to students, colleagues, the school, and the public.",
		"Select actions that preserve student welfare, professional integrity, and public trust."
	],
	"flow": [
		"Module landing and lesson outline.",
		"Scenario: Field Trip.",
		"Perspective videos and ethical reflection.",
		"Explore ethical principles and decision criteria.",
		"Review and analysis of the appropriate course of action.",
		"Ethical situations practice.",
		"Five-question end-of-module knowledge check."
	],
	"scenarios": [
		{
			"id": "module-4-field-trip",
			"title": "Field Trip",
			"summary": "A school field trip creates ethical questions about student supervision, colleague conduct, policy compliance, and maintaining school-community trust."
		}
	],
	"ethicalSituations": [
		"Student Supervision",
		"Colleague Concern",
		"Policy Compliance",
		"Confidential Information",
		"Public Trust",
		"Professional Integrity"
	],
	"ethicalPrinciples": [
		"Ensuring Student Welfare",
		"Stewardship of the Law and Public Trust",
		"Transparency in Actions and Communications",
		"Risk Mitigation",
		"Integrity of the Profession Is Promoted by the Educator",
		"Code of Ethics for Educators Is Maintained with Fidelity"
	],
	"sources": {
		"curriculum": "../../../../.working/Praxis ProEthics/Content/curriculum/modules/module-4/module.md",
		"primary": "../../../../.working/Praxis ProEthics/Content/Module 4/SCORM/Module 4_Rise and Storyline Version V4_Updated.docx",
		"scorm": "../../../../.working/Praxis ProEthics/Content/Module 4/SCORM/Module 4_Rise and Storyline Version V4_Updated.docx",
		"transcripts": [
			"../../../../.working/Praxis ProEthics/Content/Module 4/Dialogue Transcript/Bolden and Gonzalez Dialogue Transcript.docx",
			"../../../../.working/Praxis ProEthics/Content/Module 4/Dialogue Transcript/Teachers Lounge Dialogue Transcript.docx"
		],
		"videos": []
	}
}
